import React, { FC, useEffect, useState } from 'react';

import { Radio, Row } from 'antd';
import SelectorWrapper from 'src/components/general/ScrollableSelector';
import DonationItem from 'src/components/DonationItem';
export interface ICheckoutDonationProps {
  donations: number[];
  selectedDonation: number;
  setSelectedDonation: React.Dispatch<React.SetStateAction<number>>;
}

const DonationSelector: FC<ICheckoutDonationProps> = (props): JSX.Element => {
  const { donations, selectedDonation, setSelectedDonation } = props;

  const renderElement = (donation: number) => {
    return (
      <DonationItem
        key={donation}
        donation={donation}
        selected={donation === selectedDonation}
      />
    );
  };

  return (
    <Row justify="center">
      <div className="donation-selector__container">
        {
          <Radio.Group
            className="donation-item donation-selector__wrapper"
            onChange={(e) => {
              setSelectedDonation(e.target.value);
            }}
          >
            <SelectorWrapper
              data={donations}
              render={renderElement}
              type="product"
              isDonation={true}
            />
          </Radio.Group>
        }
      </div>
    </Row>
  );
};

export default DonationSelector;
